import React from "react";

import { faCalendarDays } from "@performyard/fontawesome/pro-solid-svg-icons";
import { Icon, Tooltip } from "@performyard/py-components";
import type { MeetingModelJson } from "@performyard/service-contracts";

import { GoogleCalendarIcon } from "../../../UserSettings/Views/MeetingsIntegrations/components/GoogleCalendarIcon";
import { OutlookCalendarIcon } from "../../../UserSettings/Views/MeetingsIntegrations/components/OutlookCalendarIcon";

type MeetingCalendarIconProps = {
	meeting: MeetingModelJson;
};

/**
 * Integrations-column calendar icon. Grayed when the meeting isn't on a calendar;
 * shows the connected provider's logo otherwise. Hover reveals the connection status.
 */
const MeetingCalendarIcon = ({ meeting }: MeetingCalendarIconProps): React.ReactElement => {
	const provider = meeting.calendarEvent?.eventId ? meeting.calendarEvent.provider : undefined;

	let icon: React.ReactNode;
	let tooltip: string;
	if (provider === "google") {
		icon = <GoogleCalendarIcon size={20} />;
		tooltip = "On Google Calendar";
	} else if (provider === "outlook") {
		icon = <OutlookCalendarIcon size={20} />;
		tooltip = "On Outlook Calendar";
	} else {
		icon = <Icon size={20} icon={faCalendarDays} color="neutral-2" />;
		tooltip = "Not on Calendar";
	}

	return (
		<Tooltip content={tooltip} placement="top">
			<div className="flex h-5 w-5 items-center justify-center">{icon}</div>
		</Tooltip>
	);
};

export default MeetingCalendarIcon;
